"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Youtube = /** @class */ (function () {
    function Youtube(config) {
        this.providerDisplay = 'Youtube';
        this.providerName = 'youtube';
        this.providerUrl = 'https://www.youtube.com';
        this.providerIcon = 'https://s.ytimg.com/yts/img/favicon-vfl8qSV2F.ico';
        this.type = 'video';
        this.regex = /(http:|https:)?(\/\/)?(www\.)?(youtube.com|youtu.be)\/(watch|embed)?(\?v=|\/)?(\S+)?/;
        // For some strange reason typings fails without the typing
        this.oembedFetchMode = 'no-cors';
        this.config = __assign({}, config);
    }
    Youtube.prototype.parseData = function (data) {
        var parsedData = __assign({}, data);
        var thumbnailUrl = parsedData.thumbnailUrl;
        if (thumbnailUrl) {
            parsedData.originalThumbnailUrl = thumbnailUrl;
            parsedData.thumbnailUrl = thumbnailUrl.replace('hqdefault.jpg', 'maxresdefault.jpg');
        }
        return parsedData;
    };
    return Youtube;
}());
exports.Youtube = Youtube;
